import ButtonEl from './ctas/Button'

/**
 * Resolves the className for a text-type CTA based on the panel background.
 *
 * - Dark panel  → white text (the secondary/highlight colour would be illegible)
 * - Light panel → secondary colour (the default brand highlight treatment)
 * - No panel context (e.g. regular hero, inherited from Section) → secondary colour
 *
 * Primary and secondary button types use global CSS variables that are consistent
 * across all section backgrounds by design — no overrides needed for those types.
 */
const resolveTextCtaClass = (panelTheme) => {
  if (panelTheme === 'dark') return 'text-white'
  return 'text-(--color-secondary)'
}

const HeroCtaBlock = (props) => {

  const ctaLinkItems = (props.ctaLinkItem || []).filter((ctaLinkItem) => ctaLinkItem.link?.url)
  if (!ctaLinkItems.length) {
    return
  }

  return (
    <div
      className={`basis-${props.basis ? props.basis : 'auto'} flex flex-row flex-wrap items-start mt-10 ${props.textAlignment.flex === 'center' ? 'justify-center' : 'justify-start'}`}
    >
      {ctaLinkItems.map((ctaLinkItem, i) => {
        return (
          <ButtonEl
            className={`has-[~:not([hidden])]:mb-6 has-[~:not([hidden])]:mr-6 ${ctaLinkItem.linkType.toLowerCase() === 'text' ? resolveTextCtaClass(props.panelTheme) : ''} !font-medium`}
            key={i}
            link={ctaLinkItem.link}
            theme={ctaLinkItem.linkType.toLowerCase()}
            icon={ctaLinkItem.linkIconClass}
            position={ctaLinkItem.linkPosition}
          />
        )
      })}
    </div>
  )
}

export default HeroCtaBlock
